import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type UpdateWebhookRows = {
  label: vp.UpdateWebhookLabel;
  id: vp.UpdateWebhookId;
  preset: keyof vp.TextFieldPresets;
  type: 'url' | 'input';
  required: boolean;
};

const useBuildUpdateWebhookRows = (): UpdateWebhookRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Update.Form' });
  return [
    {
      label: t('transactionStatusWebHookURL'),
      id: vp.UpdateWebhookId.TransactionStatusWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('elinxStatusWebHookURL'),
      id: vp.UpdateWebhookId.ElinxStatusWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountStatusWebHookURL'),
      id: vp.UpdateWebhookId.AccountStatusWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('batchRequestWebHookURL'),
      id: vp.UpdateWebhookId.BatchRequestWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('bankAccountCreationWebHookURL'),
      id: vp.UpdateWebhookId.BankAccountCreationWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('batchDetailWebhookUrl'),
      id: vp.UpdateWebhookId.BatchDetailWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('scheduledTransactionsWebhookUrl'),
      id: vp.UpdateWebhookId.ScheduledTransactionsWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountVerificationsWebhookUrl'),
      id: vp.UpdateWebhookId.AccountVerificationsWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('transactionGroupWebhookUrl'),
      id: vp.UpdateWebhookId.TransactionGroupWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountBalanceWebhookUrl'),
      id: vp.UpdateWebhookId.AccountBalanceWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('clientAccountBalanceWebhookUrl'),
      id: vp.UpdateWebhookId.ClientAccountBalanceWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('paymentReceivedWebhookUrl'),
      id: vp.UpdateWebhookId.PaymentReceivedWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountLimitWebhookUrl'),
      id: vp.UpdateWebhookId.AccountLimitWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('virtualTransactionWebhookUrl'),
      id: vp.UpdateWebhookId.VirtualTransactionWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('creditCardConnectionWebhookUrl'),
      id: vp.UpdateWebhookId.CreditCardConnectionWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('debitCardConnectionWebhookUrl'),
      id: vp.UpdateWebhookId.DebitCardConnectionWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
  ];
};
export default useBuildUpdateWebhookRows;
